import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const PredictiveGoals = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = true,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    data-test="predictive-goals-icon"
    height={height}
    width={width}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.57968 11.9576C8.57968 10.047 10.1349 8.50939 12.0396 8.50939C13.9445 8.50939 15.498 10.0481 15.498 11.9576C15.498 13.8664 13.9452 15.4051 12.0396 15.4051C10.1342 15.4051 8.57968 13.8667 8.57968 11.9576ZM10.2128 11.9576C10.2128 12.951 11.0273 13.7695 12.0396 13.7695C13.051 13.7695 13.8656 12.9511 13.8656 11.9576C13.8656 10.9641 13.051 10.1457 12.0396 10.1457C11.0273 10.1457 10.2128 10.9642 10.2128 11.9576Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.56007 11.958C5.56007 8.38817 8.46646 5.50527 12.0397 5.50527C15.6129 5.50527 18.5192 8.38817 18.5192 11.958C18.5192 15.5272 15.6129 18.4108 12.0397 18.4108C8.46646 18.4108 5.56007 15.5279 5.56007 11.958ZM7.19251 11.9573C7.19251 14.608 9.36173 16.7745 12.0397 16.7745C14.7176 16.7745 16.8868 14.608 16.8868 11.9573C16.8868 9.30664 14.7176 7.14015 12.0397 7.14015C9.36173 7.14015 7.19251 9.30664 7.19251 11.9573Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2.5C17.241 2.5 21.5 6.72876 21.5 11.958C21.5 14.6925 20.3323 17.1541 18.4712 18.8793L19.5017 20.163C19.7871 20.5186 19.7291 21.0407 19.3726 21.3238C19.0227 21.6018 18.516 21.5447 18.2357 21.1956L17.1817 19.8832C15.6913 20.8518 13.9121 21.4161 12 21.4161C10.0795 21.4161 8.29264 20.8467 6.7981 19.8701L5.73623 21.1948C5.45605 21.5443 4.94913 21.6019 4.59881 21.3239C4.24214 21.041 4.18376 20.5188 4.469 20.1629L5.51128 18.8626C3.66032 17.1386 2.5 14.6841 2.5 11.958C2.5 6.72876 6.75901 2.5 12 2.5ZM12 4.13558C7.65644 4.13558 4.13244 7.65072 4.13244 11.958C4.13244 16.2654 7.65644 19.7805 12 19.7805C16.3436 19.7805 19.8676 16.2654 19.8676 11.958C19.8676 7.65004 16.3436 4.13558 12 4.13558Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
